import dictionary from './dictionary.json.js';
const config = {
    resource: 'next-typeahead',
    dictionary,
};
export default config;
//# sourceMappingURL=config.js.map